import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_979_593)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.33331 7.99992H14.6666M1.33331 7.99992C1.33331 11.6818 4.31808 14.6666 7.99998 14.6666M1.33331 7.99992C1.33331 4.31802 4.31808 1.33325 7.99998 1.33325M14.6666 7.99992C14.6666 11.6818 11.6819 14.6666 7.99998 14.6666M14.6666 7.99992C14.6666 4.31802 11.6819 1.33325 7.99998 1.33325M7.99998 1.33325C9.6675 3.15882 10.6151 5.52794 10.6666 7.99992C10.6151 10.4719 9.6675 12.841 7.99998 14.6666M7.99998 1.33325C6.33246 3.15882 5.38481 5.52794 5.33331 7.99992C5.38481 10.4719 6.33246 12.841 7.99998 14.6666",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_979_593",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgGlobe;
